const API_PATH = '/context/tescucha/api/v1';

/**
 * Devuelve la URL base del API. Si existe REACT_APP_BASE_URL se usa;
 * si no, se construye desde el origen actual (window.location.origin) + path fijo.
 */
export function getBaseUrl(): string {
  const env = process.env.REACT_APP_BASE_URL;
  if (env) return env;
  if (typeof window !== 'undefined') {
    return `${window.location.origin}${API_PATH}`;
  }
  return '';
}

export interface ConfigsInterface {
  MENSAJE_ERROR_CONSULTA_CATALOGO: string;
  MENSAJE_ERROR_CONSULTA_FOLIO: string;
  MENSAJE_ERROR_CARGA_FORMULARIO: string;
  MENSAJE_ERROR_DESCARGA_ARCHIVO: string;
  MENSAJE_ERROR_GUARDAR_FORMULARIO: string;
  MENSAJE_ERROR_GENERAR_TOKEN: string;
  MENSAJE_ERROR_ACCESO_LOGIN: string;
  MENSAJE_ACCESO_DENEGADO: string;
  profile: {
    BASE_URL: string;
  };
}

export const globalConfig: ConfigsInterface = {
  MENSAJE_ERROR_CONSULTA_CATALOGO: 'TPRTE0008 - Error al consultar información de catálogo',
  MENSAJE_ERROR_CONSULTA_FOLIO: 'TPRTE0006 - Error al consultar información de folio',
  MENSAJE_ERROR_CARGA_FORMULARIO: 'TPRTE0007 - Error al cargar formulario buzón TEscucha',
  MENSAJE_ERROR_DESCARGA_ARCHIVO: 'TPRTE0009 - Error al descargar archivo buzón TEscucha',
  MENSAJE_ERROR_GUARDAR_FORMULARIO: 'TPRTE0010 - Error al guardar formulario buzón TEscucha',
  MENSAJE_ERROR_GENERAR_TOKEN: 'TPRTE0011 - Error al generar token de autenticación',
  MENSAJE_ERROR_ACCESO_LOGIN: 'TPRTE0012 - Error al acceder a administración buzón TEscucha',
  MENSAJE_ACCESO_DENEGADO: 'No cuentas con acceso a la aplicación',
  profile: {
    get BASE_URL(): string {
      return getBaseUrl();
    },
  },
};

export const CLOUD_FLARE_CAPTCHA = 'CLOUD_FLARE';
export const GOOGLE_RECAPTCHA = 'RECAPTCHA';
export const NONE_CAPTCHA = 'NONE';
